// LAZY LOADING
var L = [].slice.call(document.querySelectorAll('.lazy'));
if('IntersectionObserver' in window){
  let o = new IntersectionObserver(function(E, observer){
    E.forEach(function(e){
      if(e.isIntersecting){
        let l = e.target;
        if(l.tagName == 'IMG'){
          l.src = l.dataset.src;
        }
        if(l.tagName == 'VIDEO'){
          var P = l.play();
          if(P !== undefined){
            P.catch(error => {
              l.controls = true;
              l.classList.add('no-autoplay');
            });
          }
        }
        l.classList.remove('lazy');
        o.unobserve(l);
      }
    });
  });
  L.forEach(function(l){
    o.observe(l);
  });
}

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );
  
});

$( document ).ready(function() {
  
  setTimeout(function(){
    $( "#full-logo" ).fadeOut("fast");
  }, 5000);
  
  document.addEventListener('mousemove', (event) => {
    
    var xcords = event.clientX;
    var ycords = event.clientY;    
  
    $( ".bespoke-block-container" ).mouseenter(function() {
      $( this ).children( ".bespoke-block" ).css( "top", ycords + "px" );
      $( this ).children( ".bespoke-block" ).css( "left", xcords + "px" );
      $( this ).children( ".bespoke-block" ).addClass( "shown-bespoke" );
    });
    
  });
  
  $( ".bespoke-block-container" ).mouseleave(function() {
    $( this ).children( ".bespoke-block" ).removeClass( "shown-bespoke" );
  });
  
  $( "#bespoke-form-trigger" ).hover(
    function() {
      $( ".contact-form" ).addClass("show-form");
      $( "#bespoke-form-trigger" ).addClass("hide-form");
    }, function() {
      $( ".contact-form" ).removeClass("show-form");
      $( "#bespoke-form-trigger" ).removeClass("hide-form");
    }
  );
  
  $( "#form-trigger" ).hover(
    function() {
      $( ".contact-form" ).addClass("show-form");
      $( "#form-trigger" ).addClass("hide-form");
    }, function() {
      $( ".contact-form" ).removeClass("show-form");
      $( "#form-trigger" ).removeClass("hide-form");
    }
  );
  
  // $( "#newsletter-trigger" ).hover(
  //   function() {
  //     $( "#newsletter" ).addClass("show-form");
  //     $( "#newsletter-trigger" ).addClass("hide-form");
  //   }, function() {
  //     $( "#newsletter" ).removeClass("show-form");
  //     $( "#newsletter-trigger" ).removeClass("hide-form");
  //   }
  // );
  
  // $( "#newsletter" ).hover(
  //   function() {
  //     $( "#newsletter" ).addClass("show-form");
  //     $( "#newsletter-trigger" ).addClass("hide-form");
  //   }, function() {
  //     $( "#newsletter" ).removeClass("show-form");
  //     $( "#newsletter-trigger" ).removeClass("hide-form");
  //   }
  // );
  
  $( ".contact-form" ).hover(
    function() {
      $( ".contact-form" ).addClass("show-form");
      $( "#bespoke-form-trigger" ).addClass("hide-form");
      $( "#form-trigger" ).addClass("hide-form");
    }, function() {
      $( ".contact-form" ).removeClass("show-form");
      $( "#bespoke-form-trigger" ).removeClass("hide-form");
      $( "#form-trigger" ).removeClass("hide-form");
    }
  );
 
  $( "#bag-trigger" ).click(function() {
    $(".mini-cart").addClass("shown-mini-cart");
  });
  
  $( "#size-guide-trigger" ).click(function() {
    $(".size-guide-wrapper").fadeIn("fast");
  });
  
  $( ".size-guide-closer" ).click(function() {
    $(".size-guide-wrapper").fadeOut("fast");
  });
  
  $( "#close-cart" ).click(function() {
    $(".mini-cart").removeClass("shown-mini-cart");
  });
  
  /*var holaurl = window.location.href;
  var mySubString = holaurl.split('=').pop().split('#')[0];
  console.log(mySubString);
  
  $('.single-option-selector').on('change', function () {
    var e = document.getElementById("product-select");
    var masterSelector = e.value;
    console.log("Master value is:" + masterSelector);
    
    var holaurl = window.location.href;
    var mySubString = holaurl.split('=').pop().split('#')[0];
    console.log(mySubString);
    //$("#product-select").addClass('putamierda');
    if ( $("option").val(mySubString).is( ".soldout" ) ) {
        console.log("VENDIDO");
    }
  });*/
  

  
  //document.getElementById('product-select').addEventListener('change', function() {
  //  console.log('You selected: ', this.value);
  //});
  
});

$( "#mobile-trigger-for-menu" ).click(function() {
  $("nav").addClass("shown-nav-mobile");
});

$( "nav" ).click(function() {
  $(this).removeClass("shown-nav-mobile");
});

window.addEventListener("beforeunload", function () {
  $("body").addClass("fade-out");
});

$( window ).on( "load", function() {
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);
});

try {
  const marquee = $(".marquee");
  if (marquee.length > 0) {
  $("main").addEventListener("scroll", handleScroll);
  const marqueeHeight = marquee ? marquee.getBoundingClientRect().bottom : 0;
  const gapToHeader = 12;
  const windowHeight = window.innerHeight;
  var header = $("header");
  const mobileMenu = $("[role='navigation']");
  const mobileLogo = $("#dp-logo");
  const homeImageLink = $(".home-image-link");
  const bag = $("#bag-trigger");
  //Need to make these calls here so it works on mobile
  $(".hero-bg").css("top", marqueeHeight + "px");
  $(".marquee-wrapper").css("top", "0px");
  const marqueeAndGap = marqueeHeight + gapToHeader + "px";
  mobileLogo.css("top", marqueeAndGap);
  mobileMenu.css("top", marqueeAndGap);
  bag.css("top", marqueeAndGap);
  header.css("top", marqueeAndGap);
  homeImageLink.css("bottom", "20vh");
  
  function handleScroll() {
    const firstSectionOffset = document.querySelectorAll(".shopify-section")[1].getBoundingClientRect().top;

    //1. When the first section is on screen
    //2. When it is not on the screen yet but within header size off the screen
    //3. When it is off the screen
    if (firstSectionOffset <= windowHeight) {
      document.querySelector(".hero-bg").style.top = "-" + (windowHeight - firstSectionOffset) + "px";
      homeImageLink.style.bottom = "calc(20vh + " + (windowHeight - firstSectionOffset + marqueeHeight) + "px)";
      if (firstSectionOffset < 0) {
        console.log('asdnflk')
        bag.style.top = gapToHeader + "px";
        header.style.top = gapToHeader + "px";
      }
    }
    else if (firstSectionOffset > windowHeight && firstSectionOffset < windowHeight + marqueeHeight) {
      document.querySelector(".hero-bg").style.top = firstSectionOffset - windowHeight + "px";
      document.querySelector(".marquee-wrapper").style.top = -(marqueeHeight - (firstSectionOffset - windowHeight)) + "px";
      homeImageLink.style.bottom = "calc(20vh + " + (marqueeHeight - (firstSectionOffset - windowHeight)) + "px)";
    }
    else if (firstSectionOffset >= windowHeight + marqueeHeight) {
      resetToDefaults();
    }

    
    if (marquee && firstSectionOffset > 0 && firstSectionOffset < marquee.getBoundingClientRect().bottom + gapToHeader) {
      mobileLogo.style.top = firstSectionOffset + gapToHeader + "px";
      mobileMenu.style.top = firstSectionOffset + gapToHeader + "px";
      header.style.top = firstSectionOffset + gapToHeader + "px";
      bag.style.top = firstSectionOffset + gapToHeader + "px";
    }
  }
  
  function resetToDefaults() {
    document.querySelector(".hero-bg").style.top = marqueeHeight + "px";
    if (document.querySelector(".marquee-wrapper")) {
      document.querySelector(".marquee-wrapper").style.top = "0px";
    }
    mobileLogo.style.top = marqueeHeight + gapToHeader + "px";
    mobileMenu.style.top = marqueeHeight + gapToHeader + "px";
    bag.style.top = marqueeHeight + gapToHeader + "px";
    header.style.top = marqueeHeight + gapToHeader + "px";
    homeImageLink.style.bottom = "20vh";
  }}
} catch (error) {
  console.log(error)
}
